import VerificationsGrid from "../components/verifications/verificationGrid";

export default function Home() {
    return <VerificationsGrid />;
}
